// @ts-nocheck
import { lazy, Suspense } from 'react'
import { normalizeLanguageCode } from '../../lib/i18n'
import { BrandedText, LANDING_TRANSLATIONS } from './public-data'
import { PublicTopbar } from './PublicTopbar'
import { PublicFooter } from './PublicFooter'

const LandingBelowFold = lazy(() => import('./LandingBelowFold'))

export const Landing = ({ Topbar = PublicTopbar, Footer = PublicFooter, onStart, onLogin, onSignup, lang, setLang, navigate, onContact, onHelpCenter, onLanguages }) => {
  const isRTL = lang === 'AR'
  const lcLang = normalizeLanguageCode(lang)
  const lc = LANDING_TRANSLATIONS[lcLang] || LANDING_TRANSLATIONS.EN
  const stats = lc.stats

  const scrollToPricing = () => {
    const scroll = () => document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth', block: 'start' })
    if (document.getElementById('pricing')) {
      scroll()
      return
    }
    window.setTimeout(scroll, 120)
  }

  return (
    <div className="bbg-landing" dir={isRTL ? 'rtl' : 'ltr'}>
      <Topbar onLogin={onLogin} onSignup={onSignup} lang={lang} setLang={setLang} navigate={navigate} />

      <main id="top">
        <section className="bbg-hero">
          <div className="bbg-hero-inner">
            <div className="bbg-label bbg-label-gold bbg-hero-badge"><BrandedText>{lc.labelHero}</BrandedText></div>
            <h1>{lc.heroTitle[0]} {lc.heroTitle[1]} {lc.heroTitle[2]} <span><BrandedText>{lc.heroTitle[3]}</BrandedText></span></h1>
            <p className="bbg-hero-sub">
              <BrandedText>{lc.heroSub}</BrandedText>
            </p>
            <div className="bbg-cta-row">
              <button type="button" className="bbg-btn bbg-btn-primary" onClick={scrollToPricing}>{lc.exploreCta}</button>
              <button type="button" className="bbg-btn bbg-btn-ghost" onClick={() => onStart('basic')}>{lc.heroStartCta || lc.writeCta}</button>
            </div>
            <p className="bbg-trust">{lc.trust}</p>
          </div>
        </section>

        <section className="bbg-landing-stats" aria-label="BookBuilderGo stats">
          <div className="bbg-stat-bar bbg-stat-bar--landing">
            {stats.map(([value, label]) => (
              <div className="bbg-stat-card" key={label}>
                <strong>{value}</strong>
                <span>{label}</span>
              </div>
            ))}
          </div>
        </section>

        <Suspense fallback={<div className="bbg-below-fold-skeleton" aria-hidden="true" />}>
          <LandingBelowFold lc={lc} lcLang={lcLang} onStart={onStart} />
        </Suspense>
      </main>

      <Footer lc={lc} navigate={navigate} onContact={onContact} onHelpCenter={onHelpCenter} onLanguages={onLanguages} lang={lang} />
    </div>
  )
}
